import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { Geo, GeoAltFill } from "react-bootstrap-icons";
import UserViewCounter from "./UserViewCounter/UserViewCounter";

function SiteViewsCounters({ siteData }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "white",
        padding: { xs: "12px", md: "24px 48px" },
        borderRadius: "20px",
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      <Box
        tag="site-name"
        sx={{
          width: {
            xs: "100%",
            sm: "20%",
          },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRight: {
            xs: "none",
            lg: "0.5px solid #e7e7e7",
          },
          borderBottom: {
            xs: "0.5px solid #e7e7e7",
            lg: "none",
          },
          padding: {
            xs: "20px 8px",
            md: "20px 0",
          },
        }}
      >
        <GeoAltFill fill={theme.palette.primary[600]} size={32} />
        <Typography variant="h5" fontWeight={600} textAlign={"center"}>
          {siteData?.name}
        </Typography>
      </Box>
      <Box>
        {siteData?.Users?.map((u, i) => (
          <UserViewCounter userData={u} key={i} />
        ))}
      </Box>
    </Box>
  );
}

export default SiteViewsCounters;
